export function whatsappLink(phone, message = "") {
  if (!phone) return "";

  let digits = String(phone).replace(/\D/g, "");

  if (!digits) return "";

  // adiciona +55 se necessário
  if (digits.length <= 11) {
    digits = "55" + digits;
  }

  const url = `https://wa.me/${digits}`;

  return message
    ? `${url}?text=${encodeURIComponent(message)}`
    : url;
}

export function orderReadyMessage(order, companyName = "") {
  const num = String(order.number || "").padStart(4, "0");

  // dispositivo + marca + modelo
  const device = [
    order.equipment,
    order.brand,
    order.model
  ]
    .filter(Boolean)
    .join(" ");

  const firstName =
    order.client_name?.split(" ")[0] || "cliente";

  const value = new Intl.NumberFormat("pt-BR", {
    style: "currency",
    currency: "BRL",
  }).format(order.value || 0);

  return `Olá, ${firstName}!

✓ Temos uma boa notícia: sua ordem de serviço *#${num}* (${device}) já está pronta.

$ Valor total: *${value}*

Você já pode vir retirar seu equipamento na ${
    companyName || "assistência"
  }.

► Retirada:
Avenida Joaquim Dornelas 1338, Vila Bandeirante.

Se tiver qualquer dúvida, estamos à disposição.

Obrigado pela preferência!`;
}